// extracted by mini-css-extract-plugin
export var macValuesCompass = "index-module--mac-values-compass--6775d";